<svg width="523" height="661" viewBox="0 0 523 661" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="72.0842" cy="116.178" r="65" transform="rotate(-174.257 72.0842 116.178)" fill="url(#paint0_linear_28_733)"/>
    <circle cx="58.7563" cy="236.406" r="29" transform="rotate(-174.257 58.7563 236.406)" fill="url(#paint1_linear_28_733)"/>
    <circle cx="467.538" cy="22.538" r="20.5818" transform="rotate(-174.257 467.538 22.538)" fill="url(#paint2_linear_28_733)"/>
    <circle cx="380.5" cy="371.15" r="289.5" fill="url(#paint3_linear_28_733)"/>
    <defs>
    <linearGradient id="paint0_linear_28_733" x1="72.0842" y1="181.178" x2="345.593" y2="-173.114" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint1_linear_28_733" x1="58.7563" y1="265.406" x2="-16.4455" y2="154.505" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint2_linear_28_733" x1="467.538" y1="43.1197" x2="414.166" y2="-35.5885" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint3_linear_28_733" x1="196" y1="171.65" x2="774" y2="788.65" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    </defs>
  </svg>